import React from "react";

interface ITransactionAuditContext {
  setModalOpen: (open: boolean) => void;
  setExtnTxnId: (id: string | null | any) => void;
  isEditing: boolean;
  setIsEditing: (editing: boolean) => void;
  isRefresh: boolean;
  setIsRefresh: (refresh: boolean) => void;
}

export const TransactionAuditContext =
  React.createContext<ITransactionAuditContext>({} as ITransactionAuditContext);
